define((require) => {
    "use strict";

    var DashboardConfigurationFactory = require("ui/dashboard/DashboardConfigurationFactory");

    // This singleton is necessary because the EditorRouter uses the values to set locations.
    return DashboardConfigurationFactory.create();
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/DashboardConfiguration.js